import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopupPosition } from '../copy-button/copy-button.component';

export interface TextPopupData {
  title: string;
  text: string;
}

@Component({
  selector: 'app-text-popup',
  templateUrl: './text-popup.component.html',
  styleUrls: ['./text-popup.component.scss'],
})
export class TextPopupComponent {
  public popupPosition = PopupPosition;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TextPopupData,
    public dialogRef: MatDialogRef<TextPopupComponent>
  ) {}

  public closeWindow(): void {
    this.dialogRef.close();
  }
}
